module.exports = __webpack_public_path__ + "img/star-outline.bd41376e.svg";